
import React from 'react';
import { useSubscriptionStatusComponent } from '@/hooks/useSubscriptionStatusComponent';

/**
 * Composant qui affiche le statut d'abonnement approprié
 * en fonction de l'état actuel de l'utilisateur.
 */
const SubscriptionStatus: React.FC = () => {
  // Utiliser le hook pour déterminer quel composant afficher
  const subscriptionComponent = useSubscriptionStatusComponent();
  
  return subscriptionComponent;
};

export default SubscriptionStatus;
